import { createSelector } from 'reselect';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';
import { getMediaById } from './media';

type State = string | null

export default function mediaDrag(state: State = null, action: Actions): State {
  switch (action.type) {
    case getType(actions.startDragMedia): {
      return action.payload
    }

    case getType(actions.endDragMedia): {
      return null
    }
  }

  return state
}

function getRoot(state: StoreState) { return state.mediaDrag }

export const selectDraggedMedia = createSelector(
  getRoot,
  getMediaById,
  (id, mediaById) => {
    return id && mediaById[id] || null
  },
)
